import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { fileViewIconsMapper, fileViewOptions } from "./constants";
import DropdownButtonComponent from "@CubeComponents/form/DropdownButtonComponent";

interface ToolbarProps {
  toolbarClick: Function;
  toolbarItems: any;
  allowViewFileOptions: boolean;
  filesViewMode: string;
  setFilesViewMode: Function;
}
const Toolbar = ({
  toolbarClick = () => {},
  toolbarItems = [],
  allowViewFileOptions,
  filesViewMode,
  setFilesViewMode,
}: ToolbarProps) => {
  const handleToolBtnClick = (e: any, id: string) => {
    e.stopPropagation();
    toolbarClick(e, id);
  };

  const handleOptionsViewClick = (args: any) => {
    setFilesViewMode(args.item.id);
  };

  return (
    <div className="flex gap-5 border overflow-auto border-none border-b-button_light w-full p-4">
      <div className="flex justify-between w-full items-center">
        <div className="flex gap-5 items-center">
          {toolbarItems.map(
            (item: any) =>
              (item.align == "left" || !item.align) &&
              item.show &&
              (item.template ?? (
                <ButtonComponent
                  id={item.id}
                  onClick={(e) => handleToolBtnClick(e, item.id)}
                  key={item.id}
                  buttonType={BUTTON_TYPES.TEXT_BUTTON}
                >
                  <div className="flex items-center gap-2">
                    <IconComponent name={item.iconName} />
                    {item.text}
                  </div>
                </ButtonComponent>
              )),
          )}
        </div>
        <div className="flex gap-5 items-center">
          {toolbarItems.map(
            (item: any) =>
              item.align == "right" &&
              item.show &&
              (item.template ?? (
                <ButtonComponent
                  id={item.id}
                  onClick={(e) => handleToolBtnClick(e, item.id)}
                  key={item.id}
                  buttonType={BUTTON_TYPES.TEXT_BUTTON}
                >
                  <div className="flex items-center gap-2">
                    <IconComponent name={item.iconName} />
                    {item.text}
                  </div>
                </ButtonComponent>
              )),
          )}
          {allowViewFileOptions && (
            <DropdownButtonComponent
              select={handleOptionsViewClick}
              cssClass="e-caret-hide"
              bgColor="transparent"
              items={fileViewOptions}
            >
              <IconComponent className="h-5" name={fileViewIconsMapper[filesViewMode]} />
            </DropdownButtonComponent>
          )}
        </div>
      </div>
    </div>
  );
};
export default Toolbar;
